import {DefaultAdapter} from './default.adapter';
import {WmWoundImage} from '../interfaces/wound-management/wm-wound-image';
import {AdapterOptions} from '../interfaces/adapter/adapter-options';
import {inject} from '@angular/core';
import {map} from 'rxjs/operators';

import {SyncException} from '../exceptions/sync.exception';
import {ImagesService} from '../services/core/images.service';

export class WmWoundImagesAdapter extends DefaultAdapter<WmWoundImage> {

  private readonly _imagesService: ImagesService;

  /**
   *
   * @param adapterOptions
   */
  constructor(adapterOptions: AdapterOptions<WmWoundImage>) {
    super(adapterOptions);
    this._imagesService = inject(ImagesService);
  }

  /**
   *
   * @param wmWoundImage
   */
  public override async save(wmWoundImage: WmWoundImage): Promise<WmWoundImage> {
    return this.uploadWmWoundImage(wmWoundImage);
  }

  /**
   *
   * @param wmWoundImage
   * @private
   */
  private async uploadWmWoundImage(wmWoundImage: WmWoundImage): Promise<WmWoundImage> {
    const fileResult = await this._imagesService.readImage(wmWoundImage.file);
    const response = await fetch(fileResult.webviewPath);
    const blob = await response.blob();

    const formData = new FormData();
    formData.append('wmWoundImage', JSON.stringify(this._toRemote(wmWoundImage)));
    formData.append('file', blob, wmWoundImage.uuid + '.jpg');

    return new Promise((resolve, reject) => {
      this._httpService.post<any>({
        url: [...this.generateUrl(wmWoundImage), 'upload', wmWoundImage.uuid],
      }, formData, {
        timeout: 20000
      }).pipe(map((_item) => {
        return this._fromObject(_item);
      })).subscribe({
        next: (_item) => {
          resolve(_item);
        },
        error: (error) => {
          const syncException = new SyncException('Unknown sync error');
          if(error?.status && error?.message) {
            syncException.code = error.status;
            syncException.message = error.message;
          }
          reject(syncException);
        }
      });
    });

  }
}
